import tw from 'twin.macro';

export const QuizBarWrapper = tw.div`w-full h-full`;
